import * as Yup from 'yup'

export const paymentIntialValues = () => {
    return {
        card: "",
        cardholder: "",
        cardtype: "",
        creditcardno: "",
        expiration_date: "",
        expiration_year: "",
        payType: ""
    }
}

export const paymentVS = Yup.object({
    card: Yup.string().required("This field is required"),
    cardholder: Yup.string().required("This field is required"),
    cardtype: Yup.string().required("This field is required"),
    creditcardno: Yup.string().required("This field is required"),
    expiration_date: Yup.string().required("This field is required"),
    expiration_year: Yup.string().required("This field is required"),
})